const checkForImageUrl = (url) => {
    return(url.toString().match(/\.(jpeg|jpg|gif|png|svg|webp)$/) != null);
}
export {checkForImageUrl}